import React, { useEffect, useState } from 'react';

import { Stack } from '@mui/material';

import { InputComponent } from './InputComponent';
import { OutputComponent } from './OutputComponent';
import { PendingConnections } from './PendingConnections';
import * as S from './styles';
import ToUserSelectionComponent from './ToUserSelectionComponent';
import { useUser } from 'global/UserContext';
import { apiNetworking } from 'services/apiService';

interface MappedMember {
  label: string;
  id: string;
}

interface CommonEdge {
  type_code: string;
}

export const AtivacaoPresencial: React.FC = () => {
  const { user } = useUser();

  const [selectedUser, setSelectedUser] = useState<MappedMember | null>(null);

  const [connectionLevel, setConnectionLevel] = useState<any>(0);
  const [commonEdgeTypes, setCommonEdgeTypes] = useState<string[]>([]);

  useEffect(() => {
    fetchConnectionLevel();
    fetchCommonEdgeTypes();
  }, [selectedUser]);

  const fetchConnectionLevel = async () => {
    if (selectedUser) {
      try {
        const response = await apiNetworking.get(
          `/stats/connection/${user?.id}/${selectedUser?.id}`
        );
        setConnectionLevel(response.data?.level);
      } catch (error) {
        console.error('Error fetching members:', error);
      }
      // finally {
      //     setLoading(false);
      // }
    }
  };

  const fetchCommonEdgeTypes = async () => {
    if (selectedUser) {
      try {
        const [edgesResponse] = await Promise.all([
          apiNetworking.get(
            `/edge/find?from_user_uuid=${user?.id}&to_user_uuid=${selectedUser?.id}`
          ),
        ]);
        setCommonEdgeTypes(edgesResponse.data.map((edge: CommonEdge) => edge.type_code));
      } catch (err) {
        console.error('Error fetching data:', err);
        // setError("Failed to load data. Please try again later.");
      }
      // finally {
      // setLoading(false);
      // }
    }
  };

  return (
    <S.Wrapper>
      <Stack gap={2} direction={{ xs: 'column', sm: 'row' }} sx={{ justifyContent: 'center' }}>
        <div style={{ maxWidth: '500px' }}>
          <PendingConnections setSelectedUser={setSelectedUser} />
        </div>
        <S.Container>
          <Stack gap={1}>
            <ToUserSelectionComponent setSelectedUser={setSelectedUser} />
            {selectedUser && connectionLevel < 1 && user?.id !== selectedUser?.id && (
              <InputComponent selectedUser={selectedUser} />
            )}
            {selectedUser && (connectionLevel >= 1 || user?.id === selectedUser?.id) && (
              <OutputComponent selectedUser={selectedUser} />
            )}
          </Stack>
        </S.Container>
      </Stack>
    </S.Wrapper>
  );
};
